<template>
  <footer class="footer w-full">
    <router-link to="/">
      <img
        class="footer__logo"
        src="@/assets/images/logo-footer.png"
        height="75"
      />
    </router-link>
    <p class="font-bold">
      Gobierno de España - Ministerio de Transportes y Movilidad Sostenible
    </p>
    <p class="mb-0">
      Paseo de la Castellana 67, 28071 Madrid - Tlf. 915 977 000
    </p>
    <div class="version text-sm text-gray-400">{{ json.version }}</div>
  </footer>
</template>

<script setup>
import json from "../../../package.json";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
// #endregion

// #region Functions
function showFooter() {
  const footer = document.querySelector(".footer");
  footer.style.opacity = 1;
  footer.style.visibility = "visible";
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  showFooter,
});
// #endregion
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

.footer {
  background-color: #ecece2;
  height: fit-content;
  padding: 1rem;
  position: relative;
  opacity: 0;
  visibility: hidden;
  transition: $transition;

  .version {
    position: absolute;
    bottom: 0.5rem;
    right: 0.5rem;
  }
}

@media (min-width: $mobile-min-width) and (max-width: $mobile-max-width) {
  .footer {
    .version {
      position: relative;
      bottom: unset;
      right: unset;
      margin-top: 0.5rem;
    }
  }
}
</style>
